<i18n src="../../../locales/lang.json"></i18n>
<template>
  <div class="row p-0 m-0">
    <div class="col-12">
      <i class="icon-move handle" style="margin-top:12px;float:left;"></i>
      <button data-type='image' style="float: left; margin-left: 1px; margin-right: 1px; color: inherit" data-id='0' type='button' class='btn btn-outline btn-icon'><i class='icon-pencil6'></i></button>
      <input @change="onChange($event)" class="form-control p-1 m-0 form-control-lg col-8 col-md-8" type="text" v-model="el.Text" style="float: left;" />
      <element-controls class="element-controls" v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-controls>
    </div>
  </div>
</template>

<script>

  export default {
    name: "element-worknote",
    components: {
      
    },
    props: {
      el: {
        type: Object,
        default: null
      },
      overelement: {
        type: Object,
        default: null
      },
    },
    data() {
      return {

      };
    },
    methods: {
      onChange() {
        this.el.IsChanged = true;
        this.$store.markAsChanged();
      },
      textChanged(el) {
        el.IsChanged = true;
        el.Overridden = true;
        if (el.ParentId == null) {
          el.ParentId = el.Id;
          el.Id = -1;
        }
        this.onChange(null);
      },
      clickSettings(el) {
        this.$emit('clickSettings', el);
      },
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      deleteItem(id) {
        if (id == null || typeof id == "undefined")
          id = this.value.Id;
        this.$emit('deleteItem', id);
      },
      getId() {
        return this._uid;
      },

      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {

      }
    },
    computed: {
     
    },
    watch: {
      
    },
    mounted() {
      this.init();
    },
    created() {

    },
  };

</script>

<style scoped>

  /*Make the controls a little more quite*/

  .icon-move, .item .element-controls, .item btn-icon, .item .btn-icon i {
    color: #ddd;
  }

  .item .form-control {
    border-color: transparent;
  }

  .item:focus-within .form-control, .form-control:active, .form-control:focus {
    border-color: #2196f3;
  }

  .item:focus-within .element-controls, .item:hover .element-controls,
  .item:hover .icon-move,
  .item:focus-within .icon-move,
  .item:hover .btn-icon i, .item:focus-within .btn-icon i {
    color: black;
  }

  .item:active .custom-control-label::before, .item:focus-within .custom-control-label::before, .item:hover .custom-control-label::before {
    border-color: black;
  }

  /*End Make the controls a little more quite*/

  .handle {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-editor-elements/element-worknote.vue